export const selectCoronalMassInjection = (state) => state.coronalMassInjection;
